import { useAppLocation } from "@/lib/app-navigation";


export const useSearchData = (allProducts, allBlogs) => {
  const location = useAppLocation();
  const pathname = location.pathname;

  // Check if we are on review page
  const isReviewPage =
    pathname.includes("/my-reviews") || pathname.includes("/write-review");

  const getFilteredSuggestions = (query) => {
    const q = query?.toLowerCase().trim();
    if (!q) return [];

      //  Normal Pages: Published Products API
      const tourSugs = (allProducts || [])
        .filter((p) => {
          const tourTitle = p?.title || p?.name || "";
          return tourTitle.toLowerCase().includes(q);
        })
        .map((p) => ({
          type: "tour",
          id: p.id,
          title: p.title || p.name,
          image: p.image || (Array.isArray(p.media) ? p.media[0] : null) || (p.images && p.images[0]),
          data: p,
        }));
      // Normal Pages: Blog API
      const blogSugs = (allBlogs || [])
        .filter((b) => (b?.title || "").toLowerCase().includes(q))
        .map((b) => ({
          type: "blog",
          id: b.slug || b.id,
          title: b.title,
          image: b.image,
        }));

      return [...blogSugs, ...tourSugs].slice(0, 10);
   
  };

  return { getFilteredSuggestions, isReviewPage };
};
